export default "__VITE_ASSET__D7QYY9CM__"